export { SNSPage as default } from '@/components/enpages/Legal/SNSPolicy'
